import { apiClient } from './apiClient'
import { environment } from '../../config/environment'
import type { Stats } from '../../types/stats'
import { logger } from '../../utils/logger'

export class StatsService {
  /**
   * Récupérer les statistiques
   */
  static async getStats(): Promise<Stats> {
    const mode = environment.getConfig().mode

    if (mode === 'fake') {
      // Mode fake : utiliser des données mockées
      return await StatsService.getMockStats()
    } else {
      // Mode dev/prod : appeler l'API réelle
      logger.log('📊 Fetching real stats from API...', environment.getConfig().apiBaseUrl)
      const stats = await apiClient.get<Stats>('/v1/stats')
      logger.log('✅ Real stats received:', stats)
      return stats
    }
  }

  /**
   * Données mockées pour le mode fake ou en cas d'erreur API
   */
  private static async getMockStats(): Promise<Stats> {
    logger.log('🎭 Using mock stats data')
    
    // Simuler un délai réseau
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          totalIngredients: 100,
          totalUncategorizedIngredients: 10,
          totalProducts: 50,
          totalUncategorizedProducts: 5,
          totalBrands: 20,
          totalUncategorizedBrands: 2,
          totalUsers: 200,
        })
      }, 1000)
    })
  }
}